/**
 * 字段配置参数
 * @param {Object} override 重写参数
 * @param {string} label  标签
 * @param {string} labelWidth  标签宽度
 * @param {string} key  键值
 * @param {number} span  列数
 * @param {string} type  控件类型
 * @param {string} ref  dom引用
 * @param {any} defaultValue  默认值
 * @param {Object} props  属性-控件属性-参考element文档属性
 * @param {Object} attrs  属性-原生属性
 * @param {Object} events  事件
 * @param {Object} nativeEvents  原生事件
 * @returns
 */

// 字段配置表
export function createFieldTypes({ form } = {}) {
  // console.log(this[form]);
  let FieldTypes = {
    // 仓库
    warehouse: (override = {}) => ({
      label: "warehouse",
      labelWidth: "40px",
      key: "stockId",
      type: "Warehouse",
      ref: "queryWarehouse",
      events: {
        warehouse: this.getQueryWarehouse,
      },
      props: {
        multiple: true,
        ...override.props,
      },
      ...override,
    }),
    // 订单号
    orderNo: (override = {}) => ({
      label: "order_number",
      labelWidth: "54px",
      key: "orderNo",
      type: "Input",
      span: 8,
      attrs: {
        placeholder: `Please_enter_${override.label || "order_number"}`,
      },
      nativeEvents: {
        keyup: this.handleSearch,
      },
      ...override,
    }),
    // 运单号
    trackingNo: (override = {}) => ({
      label: "waybill_number",
      labelWidth: "54px",
      key: "trackingNo",
      ref: "queryTrackingNo",
      type: "Input",
      span: 8,
      attrs: {
        placeholder: `Please_enter_${override.label || "waybill_number"}`,
      },
      nativeEvents: {
        keyup: this.handleSearch,
      },
      ...override,
    }),
    // 任务ID
    taskId: (override = {}) => ({
      label: "taskID",
      labelWidth: "68px",
      key: "orderFulfillmentTaskId",
      type: "Input",
      span: 8,
      attrs: {
        placeholder: `Please_enter_${override.label || "taskID"}`,
      },
      nativeEvents: {
        keyup: this.handleSearch,
      },
      ...override,
    }),
    // 客户ID
    customerId: (override = {}) => ({
      label: "Customer_ID",
      labelWidth: "68px",
      key: "customerId",
      type: "Client",
      ref: "queryClient",
      span: 8,
      attrs: {
        placeholder: `Please_select_${override.label || "CustomerId"}`,
      },
      props: {
        multiple: true,
        ...override?.props,
      },
      events: {
        // 客户ID选择事件处理 --> 对应页面内要有此 method 或者传对应事件
        client:
          this.getQueryClient ||
          ((val) => {
            this[form][override.key || "customerId"] = val || "";
          }),
      },
      ...override,
    }),
    // 交易号
    csRefNo: (override = {}) => ({
      label: "transaction_number",
      labelWidth: "54px",
      key: "csrefNo",
      type: "Input",
      // ref: "queryCsrefNo",
      span: 8,
      attrs: {
        placeholder: `Please_enter_${override.label || "transaction_number"}`,
      },
      nativeEvents: {
        keyup: this.handleSearch,
      },
      ...override,
    }),
    // 时间选择
    datePicker: (override = {}) => ({
      label: "creation_time",
      labelWidth: "68px",
      key: "createTime",
      type: "DatePicker",
      pValue: override.pValue,
      span: 8,
      ref: `${override.key || "createTime"}Ref`,
      props: {
        character: "/",
      },
      events: {
        change: override.change,
      },
      ...override,
    }),
    // 创建时间 --> 基于datePicker
    createTime: (override = {}) =>
      FieldTypes.datePicker({
        props: {
          character: "-",
        },
        ...override,
      }),
    // 确认时间 --> 基于datePicker
    confirmTime: (override = {}) =>
      FieldTypes.datePicker({
        label: "verify_the_time",
        key: "confirmTime",
        props: {
          character: "/",
          ...override?.props,
        },
        change:
          override.change ||
          ((val) => {
            this[form][override.key || "confirmTime"] = val || "";
          }),
        ...override,
      }),
    // 付款时间 --> 基于datePicker
    payTime: (override = {}) =>
      FieldTypes.datePicker({
        label: "time_of_payment",
        key: "payTime",
        props: {
          character: "-",
          ...override?.props,
        },
        ...override,
      }),
    // 出库时间 --> 基于datePicker
    deliveryTime: (override = {}) =>
      FieldTypes.datePicker({
        label: "delivery_time",
        key: "deliveryTime",
        props: {
          character: "-",
          ...override?.props,
        },
        ...override,
      }),
    // 平台/店铺
    platformAndShop: (override = {}) => ({
      label: "Platform_And_Shop",
      labelWidth: "80px",
      key: "platformAndShop",
      type: "PlatformAndShop",
      ref: "searchFormPlatformAndShop",
      // isNotInit: true,
      span: 12,
      attrs: {
        placeholder: override.placeholder || "Please_Select",
      },
      props: {
        isRedColor: true,
      },
      events: {
        change: this.getPlatformAndShopData,
      },
      ...override,
    }),
    // SKU
    sku: (override = {}) => ({
      label: "Sku",
      labelWidth: "56px",
      key: "sku",
      type: "Input",
      attrs: {
        placeholder: "Please_enter_SKU",
      },
      nativeEvents: {
        keyup: this.handleSearch,
      },
      events: {},
      ...override,
    }),
    // 物流渠道
    logisticsChannel: (override = {}) => ({
      label: "logistics_channel",
      key: "labelType",
      type: "Select",
      ...override,
      attrs: {
        placeholder: "Please_select_Logistics_channel",
        ...override?.attrs,
      },
      options: filterOption.apply(this, [
        override.options || this.logisticsData || [],
      ]),
    }),
    // 国家
    country: (override = {}) => ({
      label: "country",
      labelWidth: "80px",
      key: "countryId",
      type: "Country",
      ref: "queryCountry",
      events: {
        country:
          this.getQueryCountry ||
          ((val) => {
            this[form][override.key || "countryId"] = val || "";
          }),
      },
      ...override,
    }),
    // 中文品名
    cnProductName: (override = {}) => ({
      label: "Chinese_product_name",
      key: "cnName",
      type: "Input",
      nativeEvents: {
        keyup: this.handleSearch,
      },
      ...override,
    }),
    // 英文品名
    enProductName: (override = {}) => ({
      label: "English_product_name",
      key: "enName",
      type: "Input",
      nativeEvents: {
        keyup: this.handleSearch,
      },
      ...override,
    }),
    // 物流状态
    logisticsStatus: (override = {}) => ({
      label: "logistics_status",
      key: "logisticsStatus",
      type: "Select",
      ...override,
      attrs: {
        placeholder: "Please_select_logistics_status",
        ...override?.attrs,
      },
      options: filterOption.apply(this, [
        override.options || this.LogisticsStatus || [],
      ]),
    }),
    // 状态选择
    status: (override = {}) => ({
      label: "status",
      key: "status",
      type: "Select",
      ...override,
      attrs: {
        placeholder: `Please_select_${override.label}`,
        ...override?.attrs,
      },
      options: filterOption.apply(this, [override.options || []]),
    }),
    // wms状态
    wmsStatus: (override = {}) => ({
      label: "WMS_status",
      labelWidth: "75px",
      key: "wmsStatus",
      type: "Select",
      ...override,
      attrs: {
        placeholder: "Please_Select",
        ...override?.attrs,
      },
      options: filterOption.apply(this, [
        override.options || this.WMSOerderType || [],
      ]),
    }),
    // 订单来源
    orderSource: (override = {}) => ({
      label: "order_source",
      key: "orderType",
      type: "Select",
      ...override,
      attrs: {
        placeholder: "Please_Select",
        ...override?.attrs,
      },
      options: filterOption.apply(this, [override.options || this.orderSource]),
      ...override,
    }),
    // 订单类型
    orderType: (override = {}) => ({
      label: "Order_types",
      key: "fulfillmentType",
      type: "Select",
      attrs: {
        placeholder: "Please_Select",
        ...override?.attrs,
      },
      options: filterOption.apply(this, [
        override.options || this.fulfillmentType,
      ]),
      ...override,
    }),
    // 平台
    platform: (override = {}) => ({
      label: "Platform",
      key: "platform",
      type: "Select",
      span: 8,
      // modelValue: override.modelValue, // 用于配置不在表单内的数据控制
      events: {
        change:
          this.platformHandleChange ||
          ((val) => {
            this[form][override.key || "platform"] = val;
          }),
      },
      ...override,
      props: {
        multiple: true,
        ...override?.props,
      },
      attrs: {
        placeholder: "Please_select_platform",
        ...override?.attrs,
      },
      options: filterOption.apply(this, [override.options || []]),
    }),
    // 店铺
    shop: (override = {}) => ({
      label: "Store",
      key: "shop",
      type: "Shop",
      span: 8,
      ref: "queryShop",
      events: {
        shop:
          this.getQueryShop ||
          ((val) => {
            this[form][override.key || "shop"] = val || "";
          }),
      },
      ...override,
      props: {
        clearable: true,
        ...override?.props,
      },
      attrs: {
        multiple: true,
        placeholder: "Please_Select_Store",
        ...override?.attrs,
      },
    }),
    // 平台状态
    platformStatus: (override = {}) => ({
      label: "Platform_state",
      key: "platformStatus",
      type: "Cascader",
      ref: "queryPlatformState",
      style: { width: "100%" },
      events: {
        change: this.platformStatusHandleChange,
      },
      ...override,
      attrs: {
        placeholder: "Please_Select",
        ...override?.attrs,
      },
      options: override.options || this.platformStateData || [],
    }),
    // 下发状态
    dispatchStatus: (override = {}) => ({
      label: "Issue_Status",
      key: "dispatchStatus",
      type: "Select",
      ref: "queryDispatchStatus",
      ...override,
      attrs: {
        placeholder: "Please_select_Issue_Status",
        ...override?.attrs,
      },
      options: filterOption.apply(this, [
        override.options || this.dispatchStatusOptions || [],
      ]),
    }),
    // 自定义标签
    customTags: (override = {}) => ({
      label: "custom_tags",
      key: "orderCustomTags",
      type: "Select",
      ...override,
      attrs: {
        placeholder: "Please_select_Custom_Tags",
        multiple: true,
        collapseTags: true,
        ...override?.attrs,
      },
      options: (override.options || this.customTagsData || []).map((item) => ({
        label: item.tagName,
        value: item.customerDiyTagId,
      })),
    }),
    // 配货篮子(单品)
    pickingBasket: (override = {}) => {
      return {
        label: "Allotment_basket_item",
        labelWidth: "110px",
        key: "pickingBasketID",
        type: "Select",
        props: { filterable: true, ...override?.props },
        options: () => {
          return (this.pickingBasketData || []).map((item) => ({
            label: item.basketCode,
            value: item.basketID,
          }));
        },
        ...override,
      };
    },
    // 分拣篮子
    sortingBasket: (override = {}) => ({
      label: "sorting_basket",
      key: "sortingBasketID",
      type: "Select",
      props: { filterable: true, ...override?.props },
      options: () => {
        return (this.sortingBasketData || []).map((item) => ({
          label: item.basketCode,
          value: item.basketID,
        }));
      },
      ...override,
    }),
    // 配货人
    distributor: (override = {}) => ({
      label: "distributor",
      key: "distributor",
      type: "Staff",
      ref: "queryDistributor",
      events: {
        staff: (val) => {
          this?.getQueryDistributorStaff(val);
        },
        ...override?.events,
      },
      ...override,
    }),
    // 分拣人
    sorter: (override = {}) => ({
      label: "sorter",
      key: "sorter",
      type: "Staff",
      ref: "querySorter",
      events: {
        staff: (val) => {
          this?.getQuerySorterStaff(val);
        },
        ...override?.events,
      },
      ...override,
    }),
    // 发件人
    shipper: (override = {}) => ({
      label: "consigner",
      key: "shipper",
      type: "Staff",
      ref: "queryConsigner",
      events: {
        staff: (val) => {
          this?.getQueryStaff(val);
        },
        ...override?.events,
      },
      ...override,
    }),
    // 额外包材
    extraMaterial: (override = {}) => ({
      label: "Extra_packing_material",
      key: "hasExtraPackingMaterials",
      type: "Select",
      attrs: {
        placeholder: "Please_Select",
        ...override?.attrs,
      },
      options: filterOption.apply(this, [
        override.options || [
          { label: "need", value: true },
          { label: "do_without", value: false },
        ],
      ]),
      ...override,
    }),
  };

  return FieldTypes;
}

function filterOption(list = []) {
  // console.log(this, "< ==== this");
  return list.map((item) => {
    let { langLabel, label, CnName, cnName, enName, EnName, value } = item;
    let name = langLabel || label;
    let cn = CnName || cnName;
    let en = EnName || enName;
    name = name ? name : this.$i18n.locale == "zh" ? cn : en;
    return {
      label: name,
      value,
    };
  });
}
